import './PromptTextBox.scss';
import React, { useState } from 'react';
import { TextArea, Form, Icon } from 'semantic-ui-react';
import { MessageState } from './helpers/MessageUtility';
import { TrackedMessageState } from './MessagesV2';
import classNames from 'classnames';

export type PromptTextBoxProps = {
  message: MessageState;
  state: TrackedMessageState;
  inputRef: React.Ref<TextArea | HTMLInputElement>;
  onPromptValueChange: (e: React.ChangeEvent, id: number) => void;
  onKeyDown?: (e: React.KeyboardEvent, id: number) => void;
  errorMessage?: string;
};

export default function PromptTextBox({ message, state, inputRef, onPromptValueChange, onKeyDown, errorMessage }: PromptTextBoxProps) {
  const [validationError, setValidationError] = useState<string>(errorMessage);

  const validateInput = (value: string): string => {
    if (message.onValidateInput) {
      const validation = message.onValidateInput(value);
      return validation.errorMessage;
    }
    return null;
  };

  const handleChange = (e: React.ChangeEvent) => {
    const inputValue = (e.target as HTMLInputElement | HTMLTextAreaElement).value;

    // Validate the input value directly here
    const error = validateInput(inputValue);
    setValidationError(error);

    // Pass the event up to parent component
    onPromptValueChange(e, message.id);
  };

  if (message.multiLine) {
    return (
      <Form>
        <TextArea
          value={(state[message.id] ? state[message.id].text : null) || ''}
          onChange={handleChange}
          maxLength={message.maxLength}
          ref={inputRef as React.Ref<TextArea>}
          className={classNames({ error: !!validationError })}
        />
        {validationError && <div className="error-message">{validationError}</div>}
      </Form>
    );
  }

  return (
    <div className="prompt-textbox">
      {validationError && <div className="error-message">{validationError}</div>}
      <div className="ui input fluid">
        {validationError && <Icon name="exclamation triangle" color="red" className="right-aligned" />}
        <input
          className={classNames('prompt-textbox', { error: !!validationError })}
          value={(state[message.id] ? state[message.id].text : null) || ''}
          onChange={handleChange}
          onKeyDown={(e) => {
            onKeyDown?.call(null, e, message.id);
          }}
          maxLength={message.maxLength}
          ref={inputRef as React.Ref<HTMLInputElement>}
          placeholder={message.placeholder || ''}
        />
      </div>
    </div>
  );
}
